import { render, staticRenderFns } from "./AI-score.vue?vue&type=template&id=eb5c76e8"
import script from "./AI-score.vue?vue&type=script&lang=js"
export * from "./AI-score.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports